module.exports = __webpack_public_path__ + "fonts/flaticon.61f29838.ttf";